/**
 * Modes et conditions de règlement par défaut, étapes de pipeline commercial.
 * Référence : document 04 § 5.3 (`pipeline_stages`) et § 5.4 (`payment_methods`, `payment_terms`).
 */
export const DEFAULT_PAYMENT_METHODS = [
    { code: 'CB', label: 'Carte bancaire' },
    { code: 'VIREMENT', label: 'Virement', requiresReference: true },
    { code: 'PRELEVEMENT', label: 'Prélèvement', requiresReference: true },
    { code: 'CHEQUE', label: 'Chèque', requiresReference: true },
    { code: 'LCR', label: 'Lettre de change relevé', requiresReference: true },
    { code: 'ESPECES', label: 'Espèces' },
    { code: 'STRIPE', label: 'Paiement en ligne', requiresReference: true },
];
export const DEFAULT_PAYMENT_TERMS = [
    { code: 'COMPTANT', label: 'Comptant', days: 0, isDefault: true },
    { code: 'J15', label: '15 jours net', days: 15 },
    { code: 'J30', label: '30 jours net', days: 30 },
    { code: 'J30FM', label: '30 jours fin de mois', days: 30, endOfMonth: true },
    { code: 'J45FM', label: '45 jours fin de mois', days: 45, endOfMonth: true },
    { code: 'J60', label: '60 jours net', days: 60 },
];
/** Plafond légal du délai de paiement entre professionnels (article L441-10 du code de commerce). */
export const MAX_PAYMENT_TERM_DAYS = 60;
export const DEFAULT_PIPELINE_STAGES = [
    { code: 'NOUVEAU', name: 'Nouveau', position: 1, probability: 10, color: '#94A3B8' },
    { code: 'QUALIFIE', name: 'Qualifié', position: 2, probability: 30, color: '#60A5FA' },
    {
        code: 'PROPOSITION',
        name: 'Proposition envoyée',
        position: 3,
        probability: 50,
        color: '#818CF8',
    },
    { code: 'NEGOCIATION', name: 'Négociation', position: 4, probability: 70, color: '#F59E0B' },
    { code: 'GAGNE', name: 'Gagné', position: 5, probability: 100, isWon: true, color: '#22C55E' },
    { code: 'PERDU', name: 'Perdu', position: 6, probability: 0, isLost: true, color: '#EF4444' },
];
//# sourceMappingURL=payment.constants.js.map